import { doWaitImageByTime } from './../helpers/helpers';
import { V5AlexEasterEgg2 } from './V5';
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { alex } from "../characters/Alex";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V3ShowAlexEasterEgg1 } from './V3';
import Question from '../../src/shell/Questions';
import { ann } from '../characters/Ann';
import { empty } from '../characters/empty';
import { V7AlexMovingAfter } from './V7';
import { Insta } from '../../src/components/insta/InstaClass';
import { getInstaImage, checkWordInArray } from '../helpers/helpers';

export const V7AlexMoving = async (): Promise<any> => {

    if (Game.seenScenarios.includes(`V5AlexEasterEgg2`) || Game.seenScenarios.includes(`V6AlexEasterEgg2`)) {
        await mc.set((properties) => {
            properties.alexEasterEgg2 = true;
        });

    } else {

    }
    if (Game.seenScenarios.includes(`V5AfterAnnMovie`)) {
        await mc.set((properties) => {
            properties.alexKnowsMC = true;
        });

    }
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 1.2, wait: 1.2, hideText: true });
    ImageClass.setImage(images.v7.AlexMoving_1, { duration: 1, wait: 1 });
    mc.think(`Well, I can't say she doesn't look cute from behind.`);
    mc.think(`It looks like she is almost done unpacking, I better say hey before she finishes.`);
    doWaitImageByTime(images.v7.AlexMoving_2);
    mc.think(`Wait... No way... Could it be?`);
    mc.think(`Is that... Alex?`);
    if (!mc.properties.alexKnowsMC && mc.properties.alexEasterEgg2) {
        mc.think(`We chatted on Insta, but I don't think she knows how I look.`);
        mc.think(`This should be interesting.`);


    } else {
        //TODO: isn't there a scenario where alexknowsmc = true (from movie premier) and alexeasteregg2 = True as well as a alexeasteregg2 = True only?  if so thinking we need elseif and then else with some dialogue...we can add later once u confirm or refute.
    }
    ImageClass.setImage(images.v7.AlexMoving_3, { duration: 1 });
    mc.talk(`Excuse me.`);
    ImageClass.setImage(images.v7.AlexMoving_4, { duration: 1 });
    alex.talk(`Oh...`);
    mc.think(`It's really her!`);
    if (Game.seenScenarios.includes(`V7AnnPhotoShoot`)) {
        mc.think(`Ann didn't mention anything about her moving in so close to me...`);
        mc.think(`Maybe she just didn't know?`);
    }

    if (Game.seenScenarios.includes(`eveningAfterAnn`)) {
        mc.think(`I remember that Ann mentioned she was visiting her and that she lived close already... So why move to the same neighborhood?`);
    } else {
        mc.think(`I guess we are neighbors now.`);
    }
    let text = 'What are you doing here?';
    let think = false;

    ImageClass.setImage(images.v7.AlexMoving_5);
    if (mc.properties.alexKnowsMC) {
        alex.talk(`${mc.name}???`);

    } else {
        alex.talk(`Yes?`);
        text = `She doesn't know who I am...`;
        think = true;
    }

    await alex.setQuestion(new Question({ text: text, options: { think }, key: `v7AlexMovingComplimentHer` })
        .option({ title: `Flirt`, key: true })
        .option({ title: `Don't flirt`, key: false }));


    if (Question.globalAnswers.v7AlexMovingComplimentHer) {
        await mc.set((properties) => {
            properties.alexRelationship++;
        });
        if (mc.properties.alexKnowsMC) {
            mc.talk(`Hey Alex! You are looking good!\nI live just around the corner.`);

            ImageClass.setImage(images.v7.AlexMoving_13, { duration: 1 });
            alex.talk(`Haha, thank you!`);

        } else {
            mc.talk(`I saw a cute new neighbor and I figured I would come by and say hey!`);
            mc.talk(`I'm ${mc.name} by the way. Nice to meet you!`);
            ImageClass.setImage(images.v7.AlexMoving_13, { duration: 1 });
            alex.talk(`Haha, thank you! And nice to meet you too. I'm Alex.`);
            mc.think(`Oh... I know.`);
        }

    } else {
        mc.talk(`I'm your new neighbor. I just came over to welcome you to the neighborhood!`);

    }
    ImageClass.setImage({ ...images.v7.AlexMoving_5, partialsToDisplay: [{ ...images.v7.AlexMoving_5.partials.AlexMoving_5_p, options: { duration: 1 } },] });
    alex.talk(`I actually lived not far from here, I just moved to my own place.`);
    ImageClass.setImage(images.v7.AlexMoving_5);
    mc.talk(`Oh nice. So you already know your way around.`);

    if (mc.properties.alexKnowsMC) {
        ImageClass.setImage(images.v7.AlexMoving_5.partials.AlexMoving_5_p, { duration: 1 });
        alex.talk(`Yes, haha, but it's sweet that you came to say hey.`);
        if (mc.properties.alexEasterEgg2) {
            ImageClass.setImage(images.v7.AlexMoving_13, { duration: 1 });
            alex.talk(`It's a funny coincidence to see you are after we chatted for a bit...`);
            ImageClass.setImage(images.v7.AlexMoving_5, { duration: 1 });
            mc.think(`You mean after you sent me some naked photos... I know you were covered... But still.`);
            ImageClass.setImage(images.v7.AlexMoving_5.partials.AlexMoving_5_p, { duration: 1 });
            mc.talk(`Yeah... Haha.`);

        } else {

        }
    } else {
        if (!Question.globalAnswers.v7AlexMovingComplimentHer) {

            ImageClass.setImage(images.v7.AlexMoving_5.partials.AlexMoving_5_p, { duration: 1 });
            alex.talk(`Yes, haha, but it's nice that you came to say hey.`);
            alex.talk(`I'm Alex by the way.`);
            ImageClass.setImage(images.v7.AlexMoving_5);
            mc.talk(`${mc.name}.`);
        }

        if (mc.properties.annStatus === "gf") {
            ImageClass.setImage(images.v7.AlexMoving_5);
            mc.think(`I wonder if I should mention that I'm Ann's boyfriend...`);
            if (mc.properties.alexEasterEgg2) {
                mc.think(`Or the fact that she sent me an almost nude picture of her.`);
            } else {

            }
            mc.think(`I might bring it up later... For now, it's not important.`);

        } else if (mc.properties.alexEasterEgg2) {
            mc.think(`I wonder if I should mention that we exchanged pics...`);
            mc.think(`I might bring it up later... For now, it's not important.`);

        }

    }
    ImageClass.setImage(images.v7.AlexMoving_5);
    if (mc.properties.alexKnowsMC) {
        mc.talk(`I won't lie, it's surprising to see someone so young buying a house in this neighborhood.`);
        mc.talk(`I mean, it's pretty expensive.`);

    } else {
        mc.talk(`Houses here are pretty expensive. It's cool that you can afford one at such an early age.`);

    }
    ImageClass.setImage(images.v7.AlexMoving_5.partials.AlexMoving_5_p, { duration: 1 });
    alex.talk(`I haven't bought it... Yet.`);
    alex.talk(`I'm currently just renting... Hopefully I could buy it in the near future.`);
    ImageClass.setImage(images.v7.AlexMoving_5);
    mc.talk(`It's still impressive.`);

    if (mc.properties.alexKnowsMC) {
        ImageClass.setImage(images.v7.AlexMoving_5.partials.AlexMoving_5_p, { duration: 1 });
        alex.talk(`I know! I'm so lucky! My Insta is really doing well.`);
        ImageClass.setImage(images.v7.AlexMoving_5);
        mc.talk(`You are just being modest.`);
        ImageClass.setImage(images.v7.AlexMoving_5.partials.AlexMoving_5_p, { duration: 1 });
        alex.talk(`Well, other people are working so hard to get by and here I'm just uploading pictures... So it's hard for me to speak highly about myself.`);
        ImageClass.setImage(images.v7.AlexMoving_5);
        mc.talk(`I bet it's not easy.`);
        ImageClass.setImage(images.v7.AlexMoving_5.partials.AlexMoving_5_p, { duration: 1 });
        alex.talk(`It's not. I really am investing all of my time into that.`);


    } else {
        ImageClass.setImage(images.v7.AlexMoving_5.partials.AlexMoving_5_p, { duration: 1 });
        alex.talk(`Thank you!`);
        ImageClass.setImage(images.v7.AlexMoving_5);
        mc.think(`I figured she'd mention the fact that she is able to pay for it because of her Insta...`);

    }
    // TODO: if easter eggs = special conversation, if V5annmovies = special conv
    ImageClass.setImage(images.v7.AlexMoving_6, { duration: 1 });
    alex.talk(`Since we are already talking... And you seem like a nice person...`);
    alex.talk(`Can I ask you for a favor?`);

    mc.talk(`Of course, what do you need?`);
    ImageClass.setImage(images.v7.AlexMoving_9, { duration: 1 });
    alex.talk(`The haulers I hired just ditched on me!`);
    alex.talk(`Well, not completely. They said they are going for lunch and will be back once they are done.`);
    ImageClass.setImage(images.v7.AlexMoving_9);
    alex.talk(`And now I'm stuck here watching my stuff.`);
    mc.talk(`Assholes...`);
    ImageClass.setImage({ ...images.v7.AlexMoving_6, partialsToDisplay: [images.v7.AlexMoving_6.partials.AlexMoving_6_p] });
    alex.talk(`I know!`);
    ImageClass.setImage(images.v7.AlexMoving_6, { duration: 1 });
    alex.talk(`Is there a chance you could help me?`);
    alex.talk(`Please please please!`);

    mc.talk(`Of course! Sorry I didn't offer right away!`);

    ImageClass.setImage(images.v7.AlexMoving_11);
    alex.talk(`Yay! Thank you! You are a lifesaver!`);

    return jump(V7AlexRoom, "V7AlexRoom");
};
export const V7AlexRoom = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 1.2, wait: 1.2, hideText: true });
    ImageClass.setImage(images.v7.AlexMovingRoom_0, { duration: 1, wait: 1 });
    mc.talk(`That's the last one.`);
    mc.talk(`Where do you want me to put it?`);
    ImageClass.setImage(images.v7.AlexMovingRoom_1);
    alex.talk(`Haha, like you can see... you can just put it wherever.`);
    ImageClass.setImage(images.v7.AlexMovingRoom_15);
    mc.talk(`Done.`);

    alex.talk(`Thank you so much!`);
    if (mc.properties.alexKnowsMC) {
        ImageClass.setImage(images.v7.AlexMovingRoom_2);
        alex.talk(`I'm starting to get jealous of Ann! Haha.`);

    }
    alex.talk(`If it wasn't for you, I would've been standing there until they finished their lunch.`);
    ImageClass.setImage(images.v7.AlexMovingRoom_2, { duration: 1 });
    alex.talk(`If they'll get any!`);
    mc.talk(`That's the spirit.`);
    alex.talk(`Haha.`);



    ImageClass.setImage({ ...images.v7.AlexMovingRoom_15, partialsToDisplay: [images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4] });

    alex.talk(`So? What do you think about this place?`);

    mc.talk(`It's very spacious.`);
    alex.talk(`Yes!`);
    ImageClass.setImage(images.v7.AlexMovingRoom_15);
    alex.talk(`This place is something else! I'm so excited to be living alone!`);
    alex.talk(`It's going to look way better once I finish unpacking.`);
    ImageClass.setImage(images.v7.AlexMovingRoom_3);
    if (mc.properties.alexKnowsMC) {
        alex.talk(`I'm going to hang this picture on the wall above my bed!`);
        alex.talk(`Some people might call it narcissism, but who cares right?`);
        mc.talk(`Exactly.`);
        mc.think(`I mean when you look that good...`);

    } else {
        alex.talk(`By the way, don't mind this picture, I was supposed to upload it to my... Insta.\nBut instead I decided to frame it.`);
        alex.talk(`I'm going to hang it above my bed!`);
        alex.talk(`Some people might call it narcissism but who cares right?`);

        mc.think(`I wonder why she seems hesitant to mention her Insta.`);
        ImageClass.setImage(images.v7.AlexMovingRoom_15);
        alex.talk(`I didn't say it outside, but that's how I can afford renting this place.`);
        alex.talk(`You should follow me!`);
        mc.talk(`Actually, I already am.`);
        ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p);
        alex.talk(`Really? Have we... Talked before?`);
        if (mc.properties.alexEasterEgg2 || Game.seenScenarios.includes(`V3ShowAlexEasterEgg1`)) {
            if (Game.seenScenarios.includes(`V3ShowAlexEasterEgg1`)) {
                mc.talk(`Not really talked... You actually sent me a special pic of yours.`);
                ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_2);
                alex.talk(`Mmm... Really?`);

                if (alex.properties.mcWroteLoveU) {
                    alex.talk(`Oh! I think I remember! Were you the guy that wrote to me that you love me?`);
                    ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p);
                    mc.talk(`That's me.`);
                    ImageClass.setImage(images.v7.AlexMovingRoom_15);
                    alex.talk(`Such a small world!`);
                    ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4);
                    alex.talk(`I hope you liked the pic!`);
                    mc.talk(`I really did!`);
                    ImageClass.setImage(images.v7.AlexMovingRoom_15);
                    alex.talk(`That's awesome!`);

                } else {
                    let calledAlexHot = false;
                    (getInstaImage(Insta.instaProfiles?.[alex.name], `${alex.name}14`)?.mcComments?.forEach(comment => {
                        if (comment.toLocaleLowerCase().includes("hot")) {
                            calledAlexHot = true;
                        }
                    }));

                    alex.talk(`Oh! I think I remember! You told me that I'm ${calledAlexHot ? "hot" : "sexy"}!`);
                    ImageClass.setImage(images.v7.AlexMovingRoom_2, { duration: 1 });
                    alex.talk(`I hope you meant it, haha.`);
                    mc.talk(`I'm no liar.`);

                }


            } else {

                mc.talk(`We actually talked for a bit.`);
                mc.talk(`You sent me a pic of you hugging a pillow.`);
                ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_3);
                alex.talk(`Oh my! I can't believe it's you, what are the odds?`);
                mc.talk(`Pretty low.`);
                alex.talk(`I know!`);
                ImageClass.setImage({ ...images.v7.AlexMovingRoom_15, partialsToDisplay: [images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4] });
                alex.talk(`You are the only one that got it by the way...`);
                alex.talk(`It's important for me to say it so you don't think I sent it to everyone...`);
                alex.talk(`I know it sounds like a lie I would say so you don't think I'm a... Thot. But it's the truth.`);
                mc.talk(`I believe you!`);
                alex.talk(`Thank you.`);
            }

        } else {
            mc.talk(`Not really.`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_2);
            alex.talk(`Oh ok, it would've been embarrassing if we did and I didn't remember.`);
            alex.talk(`Anyway...`);

        }

        //     alex.talk(`Oh you do! Why didn't you say so?`);
        //     mc.talk(`I don't know... So you don't think I stalked you or anything.`);
        //     ImageClass.setImage(images.v7.AlexMovingRoom_2);
        //     alex.talk(`Haha, I wouldn't think that!`);
    }

    if (mc.properties.annStatus === "gf") {
        if (mc.properties.alexKnowsMC) {
            ImageClass.setImage({ ...images.v7.AlexMovingRoom_15, partialsToDisplay: [images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4] });
            alex.talk(`How are things with Ann by the way?`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15);
            mc.talk(`We are doing great.`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4);
            alex.talk(`Great to hear! She is saying only good stuff about you.`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15);
            mc.talk(`Do you both talk a lot?`);
        } else {
            mc.think(`I think it's best if I bring up Ann now... She will find out sooner or later.`);
            mc.talk(`By the way, sorry for not mentioning it earlier, but we are actually closer than you might think.`);

            ImageClass.setImage({ ...images.v7.AlexMovingRoom_15, partialsToDisplay: [images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4] });
            alex.talk(`Really? What do you mean?`);
            mc.talk(`I'm Ann's boyfriend.`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_3);
            alex.talk(`No way!`);
            ImageClass.setImage(images.v7.AlexMovingRoom_4);
            alex.talk(`Wait! It makes sense! You said your name is ${mc.name}!`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15);
            alex.talk(`And I knew you lived in this neighborhood! I'm so stupid I didn't connect the dots.`);

            ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4);
            alex.talk(`Why didn't you say so sooner?`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15);
            mc.talk(`I was about to, but then you asked me to help you with those boxes.`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4);
            alex.talk(`Oh...`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15);
            alex.talk(`Well! It doesn't matter now!`);
            alex.talk(`I'm so excited to meet you!`);
            mc.talk(`How are things between you two? I know you are really good friends... Maybe the best?`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15);
            alex.talk(`We are! But...`);

        }

        if (ann.properties.isCorrupted) {
            ImageClass.setImage(images.v7.AlexMovingRoom_15);
            alex.talk(`Things are different lately.`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_2);
            alex.talk(`We used to meet almost every day, but she's busy doing other stuff now.`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_2);
            alex.talk(`Have you seen the way she's been dressing lately?`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4);
            mc.talk(`I have.`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15);
            mc.think(`And I'm enjoying it for sure.`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_3);
            alex.talk(`I can't believe it!`);
            ImageClass.setImage({ ...images.v7.AlexMovingRoom_15, partialsToDisplay: [images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4] });
            alex.talk(`I mean, I loved what she was wearing when I saw you both at the movies.`);
            doWaitImageByTime(images.v7.AlexMovingRoom_16);
            alex.talk(`It's about time she started showing some skin!`);
            ImageClass.setImage({ ...images.v7.AlexMovingRoom_15, partialsToDisplay: [images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p] });
            alex.talk(`But I couldn't believe how quickly she has embraced it!`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4);
            alex.talk(`I remember a time I couldn't convince her to put on short jeans.`);
            alex.talk(`I bet she's got tons of confidence thanks to you.`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15);
            mc.talk(`I hope you are saying that is a good thing.`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4);
            alex.talk(`She is doing what she likes, so of course!`);
            ImageClass.setImage(images.v7.AlexMovingRoom_15);
            mc.talk(`Great, I got scared there for a second.`);

        } else {
            ImageClass.setImage({ ...images.v7.AlexMovingRoom_15, partialsToDisplay: [images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_2] });
            alex.talk(`Lately she's been unusually busy studying, so we talk mostly over the phone.`);
            alex.talk(`And it's way less than what we used to.`);

        }

        ImageClass.setImage({ ...images.v7.AlexMovingRoom_15, partialsToDisplay: [images.v7.AlexMovingRoom_15.partials.AlexMovingRoom_15_p_4] });
        alex.talk(`I wish the best for both of you!`);

    }

    ImageClass.setImage(images.v7.AlexMovingRoom_15);
    alex.talk(`I really need to start organizing all this stuff.`);
    mc.talk(`I'll let you get to it... It seems like a lot of work.`);


    doWaitImageByTime(images.v7.AlexMovingRoom_4);
    await alex.setQuestion(new Question({ text: `Wait! You can't leave without a selfie!`, options: { think: false }, key: `v7AlexMovingRoomDidSelfie` })
        .option({ title: `Agree`, key: true })
        .option({ title: `Refuse`, key: false }));


    if (Question.globalAnswers.v7AlexMovingRoomDidSelfie) {
        await mc.set((properties) => {
            properties.alexRelationship++;
        });
        mc.talk(`Sure! Let's do it!`);
        ImageClass.setImage(images.v7.AlexMovingRoom_5, { duration: 1 });
        alex.talk(`Yay!`);
        ImageClass.setImage(images.v7.AlexMovingRoom_8, { duration: 1 });
        alex.talk(`Ready?`);
        mc.talk(`Shoot.`);
        ImageClass.setImage(images.v7.AlexMovingRoom_7);
        alex.talk(`Say cheese!`);
        mc.talk(`Meat!`);
        empty.think(`*Click*`);
        ImageClass.setImage({ ...images.v7.AlexMovingRoom_12, partialsToDisplay: [images.v7.AlexMovingRoom_12.partials.AlexMovingRoom_12_p] });
        alex.talk(`Done!`);
        alex.talk(`Ok, so you are all set!`);
        ImageClass.setImage(images.v7.AlexMovingRoom_12);
        alex.talk(`Thanks again for your help!`);
        ImageClass.setImage(images.v7.AlexMovingRoom_11, { duration: 1 });
        alex.talk(`Muah!`);
        doWaitImageByTime({ ...images.v7.AlexMovingRoom_12, partialsToDisplay: [{ ...images.v7.AlexMovingRoom_12.partials.AlexMovingRoom_12_p, options: { duration: 1 } }] });
        alex.talk(`Maybe I'll invite you over to see how it turned out!`);
        doWaitImageByTime(images.v7.AlexMovingRoom_12);
        mc.talk(`I'd love that!`);
    } else {
        await mc.set((properties) => {
            properties.alexRelationship--;
        });
        mc.talk(`I'll pass.`);
        ImageClass.setImage(images.v7.AlexMovingRoom_13);
        alex.talk(`Oh... Really...?`);
        alex.talk(`Sorry... If I came off too pushy.`);
        mc.talk(`It's ok. I just prefer not to take a selfie right now.`);
        alex.talk(`I totally understand.`);

        ImageClass.setImage(images.v7.AlexMovingRoom_15, { duration: 1 });
        alex.talk(`Anyway! Thank you so much for your help.`);
        if (mc.properties.annStatus === "gf") {
            ImageClass.setImage({ ...images.v7.AlexMovingRoom_12, partialsToDisplay: [images.v7.AlexMovingRoom_12.partials.AlexMovingRoom_12_p] });
            alex.talk(`Oh...maybe you and Ann could come see the result once I'm done!`);
            if (mc.properties.alexRelationship > 0) {
                mc.talk(`I might take you up on that offer!`);
            }

        }
    }

    return jump(V7AlexMovingAfter, "V7AlexMovingAfter");
};